import React from "react";

export default function WiringDiagrams() {
  return (
    <iframe
      src="/wiring-diagrams.html"
      title="7 Hoyle Road — Electrical Wiring Diagrams"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        border: "none",
      }}
    />
  );
}
